import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query';

import {
  FetchCreatorsInSavedList,
  FetchHandleListFromSavedList,
  FetchSavedCreatorsList,
  FetchSavedListLists,
} from './api';
import { savedCreatorsListQueryKeys } from './query-keys';

const SAVED_LIST_CREATORS_LIMIT = 20;

export function savedListListsQueryOptions(workspaceId: string) {
  return queryOptions({
    queryKey: savedCreatorsListQueryKeys.lists(workspaceId),
    queryFn: ({ signal }) => FetchSavedListLists(workspaceId, signal),
  });
}

export function savedListQueryOptions(workspaceId: string, listId: string) {
  return queryOptions({
    queryKey: savedCreatorsListQueryKeys.list(workspaceId, listId),
    queryFn: ({ signal }) => FetchSavedCreatorsList(listId, signal),
  });
}

export function savedListCreatorsInfiniteQueryOptions(workspaceId: string, listId: string) {
  return infiniteQueryOptions({
    queryKey: savedCreatorsListQueryKeys.creators(workspaceId, listId),
    queryFn: ({ signal, pageParam }) => FetchCreatorsInSavedList(listId, pageParam, signal),
    getNextPageParam: (lastPage) =>
      lastPage.total_pages <= lastPage.page
        ? null
        : {
            page: lastPage.page + 1,
            limit: SAVED_LIST_CREATORS_LIMIT,
          },
    initialPageParam: null as null | {
      page: number;
      limit: number;
    },
  });
}

export function savedListHandlesQueryOptions(workspaceId: string, listId: string) {
  return queryOptions({
    queryKey: savedCreatorsListQueryKeys.handles(workspaceId, listId),
    queryFn: ({ signal }) => FetchHandleListFromSavedList(listId, signal),
  });
}
